/* eslint-disable prettier/prettier */
export default [
    {
        rank: '1st',
        prize: '₹8000/-'
    },
    {
        rank: '2nd',
        prize: '₹6000/-'
    },
    {
        rank: '3-5',
        prize: '₹2000/-'
    }, {
        rank: '6-10',
        prize: '₹1000/-'
    },
];
